import React from 'react';
interface CSVFile {
  fileName: string;
  updateTime?: string;
}
interface CSVFileListProps {
  files: CSVFile[];
  updateMessage?: string;
}
export const CSVFileList = ({
  files,
  updateMessage = 'Updated daily at 0600'
}: CSVFileListProps) => {
  return <div className="grid grid-cols-1 md:grid-cols-2 gap-2" data-id="element-19">
      {files.map((file, index) => <div key={index} className="flex items-center justify-between p-1.5 bg-gray-50 rounded text-sm" data-id="element-20">
          <span className="font-medium truncate" data-id="element-21">{file.fileName}</span>
          <span className="text-xs text-gray-500 ml-2 whitespace-nowrap" data-id="element-22">
            {file.updateTime || updateMessage}
          </span>
        </div>)}
    </div>;
};